// extracted by mini-css-extract-plugin
export var content = "header-slider-module--content--32a98";
export var description = "header-slider-module--description--0a2c4";
export var headerContainer = "header-slider-module--headerContainer--49e6e";
export var headerItem = "header-slider-module--headerItem--86d8f";
export var image = "header-slider-module--image--52680";
export var imageContainer = "header-slider-module--imageContainer--a6c82";
export var itemContainer = "header-slider-module--itemContainer--cab83";
export var link = "header-slider-module--link--bc6bf";
export var particlesContainer = "header-slider-module--particlesContainer--2a92a";
export var plate = "header-slider-module--plate--ab634";
export var sliderContainer = "header-slider-module--sliderContainer--787da";
export var title = "header-slider-module--title--27807";